import { Capacitor } from '@capacitor/core';

/**
 * True when we're running inside a *browser* on an iPhone/iPad — i.e. NOT the
 * installed native app, and NOT an installed home-screen (standalone) PWA. This
 * is exactly the audience we want to nudge toward the App Store: an iOS visitor
 * using Safari/Chrome who could be getting the real native app instead.
 */
export function isIosBrowser(): boolean {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  // Inside the Capacitor WebView they already have the app — never promote.
  if (Capacitor.isNativePlatform()) return false;

  const ua = navigator.userAgent || '';
  const classicIos = /iPhone|iPad|iPod/i.test(ua);
  // iPadOS 13+ reports a desktop Safari UA; it's a touch Mac in practice.
  const iPadOsAsMac =
    /Macintosh/i.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
  if (!classicIos && !iPadOsAsMac) return false;

  // Already installed to the home screen (standalone PWA) — don't pester them.
  const standalone =
    (navigator as Navigator & { standalone?: boolean }).standalone === true ||
    window.matchMedia?.('(display-mode: standalone)').matches === true;
  if (standalone) return false;

  return true;
}
